import List from './list'
import Details from './details'

export default {
  list: List,
  details: Details
}
